/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.blueprint.industry.rpc.IndustryRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './IndustryRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.blueprint.industry.rpc.IndustryRpc#getAllAvailableIndustries
 */
export const GET_ALL_AVAILABLE_INDUSTRIES_QUERY_FIELD_NAME = 'com_hubspot_blueprint_industry_rpc_IndustryRpc_getAllAvailableIndustries';
export const GET_ALL_AVAILABLE_INDUSTRIES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_AVAILABLE_INDUSTRIES_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAllAvailableIndustriesRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.blueprint.industry.rpc.IndustryRpc#getIndustry
 */
export const GET_INDUSTRY_QUERY_FIELD_NAME = 'com_hubspot_blueprint_industry_rpc_IndustryRpc_getIndustry';
export const GET_INDUSTRY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INDUSTRY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getIndustryRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.blueprint.industry.rpc.IndustryRpc#upsertIndustryForPortal
 */
export const UPSERT_INDUSTRY_FOR_PORTAL_MUTATION_FIELD_NAME = 'com_hubspot_blueprint_industry_rpc_IndustryRpc_upsertIndustryForPortal';
export const UPSERT_INDUSTRY_FOR_PORTAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPSERT_INDUSTRY_FOR_PORTAL_MUTATION_FIELD_NAME,
  args: ['industry'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.upsertIndustryForPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});